import * as React from 'react';
import LegalsContent from './Legals.Content';

import './Legals.page.scss';

export interface LegalsProps {
}

export class LegalsPage extends React.Component<LegalsProps, any> {
  public render() {
    return (
      <div className="page-legals pt-5 pb-5">
        <LegalsContent />
      </div>
    );
  }
}
